import { ReactComponent as CvsLogo } from 'ui-components/src/images/netapp-services/ic-cvs.svg';
import { ReactComponent as NetAppFilesLogo } from "ui-components/src/images/netapp-services/ic-netapp.svg";
import FormAws from "../components/credentials/content/FormAws";
import FormAzure from "../components/credentials/content/FormAzure";
import FormGcp from "../components/credentials/content/FormGcp";

const gcpPermissions = `
{
    "role": "compute.viewer"
}
`;

const azurePermissions = `
{
    "Name": "NetApp Azure Assessment Tool User",
    "Actions": [
        "Microsoft.Resources/subscriptions/read",
        "Microsoft.Compute/disks/read",
        "Microsoft.Compute/snapshots/read",
        "Microsoft.Compute/virtualMachines/read"       
    ],
    "NotActions": [],
    "AssignableScopes": [
        "/subscriptions/***FILL IN YOUR SUBSCRIPTION ID***"
    ],
    "Description": "Azure use assessment tool",
    "IsCustom": "true"
}
`;

const awsInitialState = {
    name: "",
    apiKey: "",
    secretKey: "",
    region: null
};

const awsValidator = state => {
    let errors = {};
    if(!state.name){
        errors.name = "Service name is required."
    }
    if(!state.apiKey){
        errors.serviceName = "Service API key is required."
    }
    if(!state.secretKey){
        errors.secretKey = "Service secrete key is required."
    }
    if(!state.region){
        errors.region = "Region selection is required."
    }
    return errors;
};

const azureInitialState = {
    name: "",
    clientId: "",
    clientSecret: "",
    tenantId: ""
};

const azureValidator = state => {
    let errors = {};
    if(!state.name){
        errors.name = "Service name is required."
    }
    if(!state.clientId){
        errors.clientId = "Client ID is required."
    }
    if(!state.clientSecret){
        errors.clientSecret = "Client secrete is required."
    }
    if(!state.tenantId){
        errors.tenantId = "Tenant id is required."
    }
    return errors;
};

const gcpInitialState = {
    name: "",
    serviceAccountCredentials: "",
    project: ""
};

const gcpValidator = state => {
    let errors = {};
    if(!state.name){
        errors.name = "Service name is required."
    }
    if(!state.serviceAccountCredentials){
        errors.serviceAccountCredentials = "Service account credentials are required."
    }
    try {
        JSON.parse(state.serviceAccountCredentials);
    } catch (e) {
        errors.serviceAccountCredentials = "Invalid JSON format."
    }
    if(!state.project){
        errors.project = "Project selection is required."
    }
    return errors;
};

export default {
    aws: {
        label: 'Cloud Volumes for AWS',
        value: 'cloud-volumes-service-aws',
        title: "AWS Cloud Volumes Service Details",
        formTitle: "Cloud Volumes Service Credentials",
        infoTitle: "How to get the credentials",
        logo: CvsLogo,
        form: FormAws,
        validator: awsValidator,
        initialState: awsInitialState,
        infoItems: [
            {
                withChevron: true,
                text: "Subscribe in the",
                linkText: "AWS Marketplace",
                href: "https://console.aws.amazon.com/marketplace/home?region=us-east-1#/landing"
            },
            {
                withChevron: true,
                text: "Log in to",
                linkText: "Cloud Volumes Service.",
                href: "https://console.aws.amazon.com/marketplace/home?region=us-east-1#/landing"
            },
            {
                withChevron: true,
                text: "Click API access, copy the credentials, and enter them in the fields on the left"
            },
            {
                text: "To learn more about Cloud Volumes Service,",
                linkText: "click here",
                href: "https://console.aws.amazon.com/marketplace/home?region=us-east-1#/landing"
            }
        ],
        submitError: "There are no cloud volumes in this region, or your credentials are not compatible with the selected region."
    },
    gcp: {
        label: 'Cloud Volumes for GC',
        value: 'cloud-volumes-service-gcp',
        title: "GCP Cloud Volumes Service Details",
        formTitle: "Cloud Volumes Service Credentials",
        infoTitle: "How to get the credentials",
        logo: CvsLogo,
        form: FormGcp,
        validator: gcpValidator,
        initialState: gcpInitialState,
        permissionsModal: {
            permissions: gcpPermissions,
            title: "Cloud Volumes Service required the following permissions:"
        },
        infoItems: [
            {
                withChevron: true,
                text: "Enable the Cloud Volumes Service API in Google Cloud.",
            },
            {
                withChevron: true,
                withModal: true,
                text: "Create a GC service account with the",
                modalButtonText: "required permissions."
            },
            {
                withChevron: true,
                text: "Download the service account credentials and paste them in the box on the left."
            },
            {
                text: "To learn more about Cloud Volumes Service,",
                linkText: "click here",
                href: "https://console.aws.amazon.com/marketplace/home?region=us-east-1#/landing"
            }
        ],
        submitError: "There are no cloud volumes in this region, or your credentials are not compatible with the selected region."
    },
    azure: {
        label: 'Azure NetApp Files',
        value: 'cloud-volumes-service-azure',
        title: "Azure NetApp Files Details",
        formTitle: "Azure NetApp Files Credentials",
        infoTitle: "How to get the credentials",
        logo: NetAppFilesLogo,
        form: FormAzure,
        validator: azureValidator,
        initialState: azureInitialState,
        permissionsModal: {
            permissions: azurePermissions,
            title: "Azure NetApp Files required the following permissions: "
        },
        infoItems: [
            {
                withChevron: true,
                withModal: true,
                text: "Create an Azure AD client application that meets the",
                modalButtonText: "required permissions.",
            },
            {
                text: "Application (client) ID - The ID of an Active Directory service principal that Cloud Manager can use to authenticate with Azure Active Directory."
            },
            {
                text: "Client Secret - The value of a client secret for the service principal application."
            },
            {
                text: "Directory (tenant) ID - The Active Directory ID for your organization. This is sometimes referred to as a Tenant ID."
            },
            {
                text: "To learn more about Cloud Volumes Service,",
                linkText: "click here",
                href: "https://console.aws.amazon.com/marketplace/home?region=us-east-1#/landing"
            }
        ],
        submitError: "There are no cloud volumes in this region, or your credentials do not have the required permissions."
    }
};
